import { createContext } from "react";

export const PurchaseValidationContext = createContext({});
